import { render, staticRenderFns } from "./StoriesButton.vue?vue&type=template&id=327a2ac8&scoped=true&"
import script from "./StoriesButton.vue?vue&type=script&lang=js&"
export * from "./StoriesButton.vue?vue&type=script&lang=js&"
import style0 from "./StoriesButton.vue?vue&type=style&index=0&id=327a2ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a2ac8",
  null
  
)

export default component.exports